import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import type { CreatePoll } from "../../../types";
import { queryKeys } from "../../query-keys";

export function usePolls(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.polls(clubId ?? ""),
		queryFn: () => clubApi.polls.list(clubId!),
		enabled: !!clubId,
	});
}

export function usePollDetail(clubId: string | null, pollId: string) {
	return useQuery({
		queryKey: queryKeys.clubPortal.pollDetail(clubId ?? "", pollId),
		queryFn: () => clubApi.polls.get(clubId!, pollId),
		enabled: !!clubId && !!pollId,
	});
}

export function useCreatePoll(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: CreatePoll) => clubApi.polls.create(clubId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "polls"],
			}),
	});
}

export function useDeletePoll(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (pollId: string) => clubApi.polls.delete(clubId, pollId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "polls"],
			}),
	});
}

export function useVotePoll(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ pollId, optionIds }: { pollId: string; optionIds: string[] }) =>
			clubApi.polls.vote(clubId, pollId, optionIds),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "polls"],
			}),
	});
}
